document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const drawer = header.querySelector('[data-mobile-menu]');
    const opener = header.querySelector('[data-menu-open]');
    const closers = header.querySelectorAll('[data-menu-close]');
    const backdrop = header.querySelector('.mobile-menu__backdrop');

    const setDrawer = (open) => {
      drawer?.classList.toggle('is-open', open);
      backdrop?.classList.toggle('is-open', open);
      drawer?.setAttribute('aria-hidden', String(!open));
      opener?.setAttribute('aria-expanded', String(open));
      opener?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('menu-open', open);
      if (open) drawer?.querySelector('button, a, summary')?.focus();
    };

    opener?.addEventListener('click', () => setDrawer(!drawer?.classList.contains('is-open')));
    closers.forEach((closer) => closer.addEventListener('click', () => setDrawer(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) setDrawer(false);
    });
    header.querySelectorAll('[data-menu-details]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        header.querySelectorAll('[data-menu-details]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  }

  document.querySelectorAll('.product-rail').forEach((railSection) => {
    const rail = railSection.querySelector('[data-product-rail]');
    if (!rail) return;
    railSection.querySelector('[data-rail-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .8, behavior: 'smooth' }));
    railSection.querySelector('[data-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .8, behavior: 'smooth' }));
  });

  document.querySelectorAll('.quantity-control').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const min = Number(input.min || 0);
      input.value = String(Math.max(min, Number(input.value || min) - 1));
    });
    control.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Number(input.value || 0) + 1));
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const chips = root.querySelectorAll('[data-variant-chip]');
    const addButton = root.querySelector('[data-add-to-bag]');
    const addLabel = root.querySelector('[data-add-label]');
    const addPrice = root.querySelector('[data-add-price]');
    const availability = root.querySelector('[data-product-availability]');
    if (!select || !idInput || !price) return;

    const updateVariant = (focusMedia = false) => {
      const option = select.options[select.selectedIndex];
      idInput.value = option.value;
      const compare = option.dataset.compare;
      price.innerHTML = `${compare ? `<s>${compare}</s>` : ''}<span>${option.dataset.price || ''}</span>`;
      const isAvailable = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !isAvailable;
      if (addLabel) addLabel.textContent = isAvailable ? 'Add to bag' : 'Sold out';
      if (addPrice) addPrice.textContent = option.dataset.price || '';
      if (availability) {
        availability.textContent = isAvailable ? 'Available' : 'Sold out';
        availability.classList.toggle('is-sold-out', !isAvailable);
      }
      chips.forEach((chip) => {
        const active = chip.dataset.variantChip === option.value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', String(active));
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      if (focusMedia && option.dataset.mediaId) {
        const media = root.querySelector(`[data-media-id="${CSS.escape(option.dataset.mediaId)}"]`);
        media?.scrollIntoView({ behavior: 'smooth', block: window.matchMedia('(max-width: 749px)').matches ? 'nearest' : 'center', inline: 'center' });
      }
    };

    select.addEventListener('change', () => updateVariant(true));
    chips.forEach((chip) => chip.addEventListener('click', () => {
      select.value = chip.dataset.variantChip;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
});
